// extracted by mini-css-extract-plugin
export default {"image":"AX-z","loaded":"BX-z"};